<p-drawer [(visible)]="visible" (visibleChange)="visibleChange.emit($event)" (onHide)="onClose()" position="right"
  styleClass="ficha-drawer" [modal]="true" [dismissible]="true" appendTo="body"
  [style]="{ width: 'min(1180px, 96vw)' }">
  <ng-template pTemplate="header">
    <div class="drawer-header-bar">
      <div class="drawer-header-title">
        <i class="ri-shield-user-line"></i>
        <span>Ficha do Efectivo</span>
        <span *ngIf="efetivo" class="drawer-id-pill">{{
          efetivo.id ? "G-" + (efetivo.id | number: "3.0-0") : ""
          }}</span>
      </div>
    </div>
  </ng-template>

  <!-- ── SKELETON ── -->
  <div *ngIf="loading" class="drawer-skeleton">
    <p-skeleton height="120px" styleClass="mb-3" borderRadius="14px"></p-skeleton>
    <p-skeleton height="48px" styleClass="mb-2" borderRadius="8px"></p-skeleton>
    <p-skeleton height="48px" styleClass="mb-2" borderRadius="8px"></p-skeleton>
    <p-skeleton height="220px" styleClass="mb-3" borderRadius="14px"></p-skeleton>
  </div>

  <!-- ── CONTEÚDO ── -->
  <div *ngIf="!loading && efetivo" class="drawer-body">
    <!-- ── HERO SECTION ── -->
    <div class="hero-section">
      <div class="hero-top">
        <div class="hero-avatar-wrap">
          <img *ngIf="efetivo.urlFotografia" [src]="fotoUrl" [alt]="efetivo.nome" class="hero-avatar-img" />
          <div *ngIf="!efetivo.urlFotografia" class="hero-avatar-initials">
            {{ getInitials(efetivo.nome) }}
          </div>
        </div>

        <div class="hero-info">
          <h2 class="hero-nome">{{ efetivo.nome }}</h2>
          <p class="hero-cargo">
            {{ efetivo.nomeFuncao || "—" }} · {{ efetivo.nomeCategoria || "—" }}
          </p>
          <div class="hero-badges">
            <span *ngIf="emServico" class="badge-servico pulse">
              <i class="fas fa-circle"></i> Em Serviço
            </span>
            <span *ngIf="postAtivo && getEstadoEfetivo(efetivo) === 0 && !emServico" class="badge-servico badge-pendente">
              <i class="ri-time-line"></i> Turno Não Iniciado
            </span>
            <span class="estado-badge" [ngClass]="getEstadoBadgeClass(efetivo.estadoEfetivo)">
              <i [class]="getEstadoIcon(efetivo.estadoEfetivo)"></i>
              {{ getEstadoLabel(efetivo.estadoEfetivo) }}
            </span>
            <span *ngIf="escalaActiva?.turnoContrato" class="badge-turno">
              <i class="fas fa-clock"></i> {{ escalaActiva.turnoContrato }}
            </span>
          </div>

          <div *ngIf="postAtivo" class="hero-posto-pill">
            <i class="ri-building-4-line"></i>
            <span>{{ postAtivo.nome }}</span>
            <span class="pill-code">{{ postAtivo.codigo }}</span>
          </div>
        </div>
      </div>

      <!-- ── ACÇÕES ── -->
      <div class="hero-actions">
        <button
          *ngIf="postAtivo && getEstadoEfetivo(efetivo) === 0 && !emServico"
          class="btn-web-danger"
          (click)="marcarFaltaNoDrawer()"
          [disabled]="loadActive"
          pTooltip="Marcar falta neste turno"
          tooltipPosition="bottom">
          <i class="ri-user-unfollow-line"></i> Marcar Falta
        </button>
        <button *ngIf="[0, 2, 3, 5].includes(getEstadoEfetivo(efetivo) ?? -1)" class="btn-web-secondary" (click)="editarEfetivo()">
          <i class="ri-edit-line"></i> Editar Ficha
        </button>
        <button *ngIf="getEstadoEfetivo(efetivo) === 0" class="btn-web-secondary btn-action-warn" (click)="abrirAfastar(efetivo)"
          [disabled]="loadActive">
          <i class="ri-user-unfollow-line"></i> Afastar
        </button>
        <button *ngIf="getEstadoEfetivo(efetivo) === 0" class="btn-web-secondary btn-action-amber" (click)="abrirSuspender(efetivo)"
          [disabled]="loadActive">
          <i class="ri-pause-circle-line"></i> Suspender
        </button>
        <button *ngIf="[0, 3, 5].includes(getEstadoEfetivo(efetivo) ?? -1)" class="btn-web-danger" (click)="ToggleStatus(efetivo)"
          [disabled]="loadActive">
          <i class="ri-ban-line"></i> Desactivar
        </button>

        <button *ngIf="[1, 2, 3].includes(getEstadoEfetivo(efetivo) ?? -1)" class="btn-web-primary" (click)="Activar(efetivo)"
          [disabled]="loadActive">
          <i class="ri-play-circle-line"></i>
          Activar
        </button>
      </div>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <i class="ri-user-3-line"></i>
        <span>Dados Pessoais</span>
      </div>
      <div class="data-grid">
        <div class="data-row">
          <span class="data-label">BI / NIF</span>
          <span class="data-value mono">{{ efetivo.numBI }}</span>
        </div>
        <div class="data-row">
          <span class="data-label">ID Interno</span>
          <span class="data-value mono">G-{{ efetivo.id }}</span>
        </div>
        <div class="data-row">
          <span class="data-label">Posto Actual</span>
          <span class="data-value bold">{{ postAtivo?.nome || "Efectivo sem Posto" }}</span>
        </div>
        <div class="data-row">
          <span class="data-label">Data de Entrada</span>
          <span class="data-value">{{ formatDate(efetivo.dataAdmissao) }}</span>
        </div>
        <div class="data-row" *ngIf="escalaActiva">
          <span class="data-label">Turno Preferencial</span>
          <span class="data-value">
            <span class="turno-inline" [class.noturno]="escalaActiva.turnoContrato === 'Noturno'"
              [class.diurno]="escalaActiva.turnoContrato === 'Diurno'">
              <i [class]="
                  escalaActiva.turnoContrato === 'Noturno'
                    ? 'ri-moon-line'
                    : 'ri-sun-line'
                "></i>
              Turno {{ escalaActiva.turnoContrato }}
              <ng-container *ngIf="escalaActiva.turnoContrato === 'Diurno'">
                — 06:00–18:00</ng-container>
              <ng-container *ngIf="escalaActiva.turnoContrato === 'Noturno'">
                — 18:00–06:00</ng-container>
            </span>
          </span>
        </div>
        <div class="data-row">
          <span class="data-label">Telefone</span>
          <span class="data-value">{{ efetivo.numTelefone || "—" }}</span>
        </div>
        <div class="data-row" *ngIf="efetivo.mac || efetivo.Mac">
          <span class="data-label">Endereço MAC</span>
          <span class="data-value mono">{{ efetivo.mac || efetivo.Mac }}</span>
        </div>
      </div>
    </div>

    <!-- ── CALENDÁRIO DE ESCALAS ── -->
    <div class="section-card calendar-card">
      <div class="section-card-header">
        <i class="fas fa-calendar-check"></i>
        <div class="section-title-stack">
          <span>Assiduidade semanal</span>
          <small>Turno previsto, entrada real, saída e ausências</small>
        </div>
        <span *ngIf="escalaSelecionada" class="selected-scale-pill">
          {{ escalaSelecionadaTitulo }}
        </span>
      </div>

      <app-escala-calendario [efetivos]="drawerEfetivos" [escalas]="escalasSemana" [semanaInicio]="semanaInicio"
        [loading]="loadingEscalas" [selectedEscalaId]="escalaSelecionadaId" [selectedDate]="escalaSelecionadaData"
        contexto="efetivo" (weekChange)="onWeekChange($event)"
        (slotClick)="onEscalaSlotClick($event)"></app-escala-calendario>
    </div>

    <!-- ── HISTÓRICO RECENTE ── -->
    <div class="section-card history-card-modern">
      <div class="section-card-header scale-history-header">
        <i class="fas fa-history"></i>
        <div class="section-title-stack">
          <span class="scale-history-title">{{ escalaSelecionadaCabecalho }}</span>
          <small *ngIf="escalaSelecionada || escalaSelecionadaCell">
            {{ escalaSelecionadaHorario }}
          </small>
        </div>
        <span *ngIf="escalaSelecionadaStatusLabel" class="scale-status-badge" [ngClass]="escalaSelecionadaStatusClasse">
          <i [class]="escalaSelecionadaStatusIcone"></i>
          {{ escalaSelecionadaStatusLabel }}
        </span>
      </div>

      <div class="scale-context-banner" *ngIf="historicoEscalaData && !loadingHistorico">
        <div class="banner-item">
          <i class="ri-building-4-line"></i>
          <div>
            <span class="lbl">Posto de Trabalho</span>
            <strong class="val">{{ historicoEscalaData.postoNome }} <small *ngIf="historicoEscalaData.postoCodigo">({{
                historicoEscalaData.postoCodigo }})</small></strong>
          </div>
        </div>
        <div class="banner-item" *ngIf="historicoEscalaData.clienteNome">
          <i class="ri-user-star-line"></i>
          <div>
            <span class="lbl">Cliente</span>
            <strong class="val">{{ historicoEscalaData.clienteNome }}</strong>
          </div>
        </div>
      </div>

      <div class="scale-full-stats-grid" *ngIf="estatisticasEscala && !loadingHistorico">
        <div class="stat-card">
          <div class="stat-card-icon blue"><i class="ri-route-line"></i></div>
          <div class="stat-card-content">
            <span class="stat-card-title">Rondas Realizadas</span>
            <strong class="stat-card-value">{{ estatisticasEscala.totalRondasConcluidas }}/{{
              estatisticasEscala.totalRondas }}</strong>
            <small class="stat-card-sub">{{ estatisticasEscala.totalPontosCriticosVerificados }} pontos checados</small>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card-icon green"><i class="ri-group-line"></i></div>
          <div class="stat-card-content">
            <span class="stat-card-title">Presença no Turno</span>
            <strong class="stat-card-value">{{ estatisticasEscala.totalEfetivosPresentes }}/{{
              estatisticasEscala.totalEfetivosEscalados }}</strong>
            <small class="stat-card-sub">{{ estatisticasEscala.totalFaltas }} faltas registadas</small>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card-icon amber"><i class="ri-alarm-warning-line"></i></div>
          <div class="stat-card-content">
            <span class="stat-card-title">Ocorrências</span>
            <strong class="stat-card-value">{{ estatisticasEscala.totalOcorrencias }}</strong>
            <small class="stat-card-sub">{{ estatisticasEscala.totalOcorrenciasAbertas }} abertas · {{
              estatisticasEscala.totalOcorrenciasFechadas }} fechadas</small>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card-icon purple"><i class="ri-restaurant-line"></i></div>
          <div class="stat-card-content">
            <span class="stat-card-title">Alimentação / Refeições</span>
            <strong class="stat-card-value">{{ estatisticasEscala.totalRefeicoesConfirmadas }}/{{
              estatisticasEscala.totalRefeicoes }}</strong>
            <small class="stat-card-sub">{{ estatisticasEscala.totalRefeicoesPendentes }} pendentes</small>
          </div>
        </div>
      </div>

      <div class="escala-op-summary"
        *ngIf="escalaIdValida && !loadingHistorico && (escalaSelecionadaEntrada || escalaSelecionadaSaida || escalaSelecionadaMotivoFalta || escalaSelecionadaCell?.estadoOperacional === 'falta' || totalOcorrenciasRegistradas > 0)">
        <div class="op-stat-pill" *ngIf="escalaSelecionadaEntrada">
          <i class="ri-login-box-line green-icon"></i>
          <div class="op-stat-info">
            <span class="op-stat-lbl">Entrada Real</span>
            <span class="op-stat-val">{{ escalaSelecionadaEntrada }}</span>
          </div>
        </div>
        <div class="op-stat-pill" *ngIf="escalaSelecionadaSaida">
          <i class="ri-logout-box-line purple-icon"></i>
          <div class="op-stat-info">
            <span class="op-stat-lbl">Saída Real</span>
            <span class="op-stat-val">{{ escalaSelecionadaSaida }}</span>
          </div>
        </div>
        <div class="op-stat-pill danger"
          *ngIf="escalaSelecionadaMotivoFalta || escalaSelecionadaCell?.estadoOperacional === 'falta'">
          <i class="ri-user-unfollow-line red-icon"></i>
          <div class="op-stat-info">
            <span class="op-stat-lbl">Ausência / Falta</span>
            <span class="op-stat-val">{{ escalaSelecionadaMotivoFalta || 'Falta Registada' }}</span>
          </div>
        </div>
        <div class="op-stat-pill" *ngIf="totalOcorrenciasRegistradas > 0">
          <i class="ri-alert-line amber-icon"></i>
          <div class="op-stat-info">
            <span class="op-stat-lbl">Ocorrências</span>
            <span class="op-stat-val">{{ totalOcorrenciasRegistradas }}</span>
          </div>
        </div>
      </div>

      <div class="sub-section-block" *ngIf="efetivosEscalaList.length && !loadingHistorico">
        <h4 class="sub-section-title"><i class="ri-user-shared-line"></i> Efectivos Escalados neste Turno</h4>
        <div class="efetivos-turno-grid">
          <div class="efetivo-turno-card" *ngFor="let ef of efetivosEscalaList">
            <div class="ef-avatar"><i class="ri-user-3-line"></i></div>
            <div class="ef-info">
              <strong>{{ ef.efetivoNome }}</strong>
              <span class="ef-papel">{{ ef.papelEfetivoEscala || 'Efectivo' }}</span>
            </div>
            <div class="ef-times">
              <span class="time-tag in" *ngIf="ef.horaInicioReal"><i class="ri-login-box-line"></i> {{
                formatTimeOnly(ef.horaInicioReal) }}</span>
              <span class="time-tag out" *ngIf="ef.horaFimReal"><i class="ri-logout-box-line"></i> {{
                formatTimeOnly(ef.horaFimReal) }}</span>
              <span class="time-tag pending" *ngIf="!ef.horaInicioReal && !ef.horaFimReal">Turno pendente</span>
            </div>
          </div>
        </div>
      </div>

      <div class="sub-section-block" *ngIf="alimentacoesEscala.length && !loadingHistorico">
        <h4 class="sub-section-title"><i class="ri-restaurant-line"></i> Registo de Alimentação / Refeições</h4>
        <div class="alimentacoes-list">
          <div class="alimentacao-card" *ngFor="let al of alimentacoesEscala">
            <div class="al-icon"><i class="ri-restaurant-2-line"></i></div>
            <div class="al-body">
              <strong>{{ al.tipoAlimentacaoNome || 'Refeição' }}</strong>
              <span class="al-user">{{ al.efetivoNome }}</span>
              <small class="al-date" *ngIf="al.dataConfirmacao"><i class="ri-time-line"></i> {{
                formatDateTime(al.dataConfirmacao) }}</small>
            </div>
            <span class="al-badge" [class.confirmed]="al.confirmado">
              <i [class]="al.confirmado ? 'ri-checkbox-circle-line' : 'ri-time-line'"></i>
              {{ al.confirmado ? 'Confirmado' : 'Pendente' }}
            </span>
          </div>
        </div>
      </div>

      <div class="sub-section-block" *ngIf="rondasEscala.length && !loadingHistorico">
        <h4 class="sub-section-title"><i class="ri-route-line"></i> Rondas Realizadas no Turno ({{ rondasEscala.length
          }})</h4>
        <div class="rondas-detail-list">
          <div class="ronda-detail-card" *ngFor="let r of rondasEscala">
            <div class="ronda-header">
              <div class="ronda-title">
                <i class="ri-shield-flash-line"></i>
                <span>Ronda #{{ r.id }} · {{ r.efetivoNome || 'Efectivo' }}</span>
              </div>
              <span class="ronda-status-badge" [class.done]="r.concluida" [class.ongoing]="!r.concluida">
                <i [class]="r.concluida ? 'ri-checkbox-circle-line' : 'ri-loader-2-line'"></i>
                {{ r.concluida ? 'Concluída' : 'Em Curso' }}
              </span>
            </div>

            <div class="ronda-meta">
              <span><i class="ri-time-line"></i> Início: {{ formatDateTime(r.dataInicio) }}</span>
              <span *ngIf="r.dataFim"><i class="ri-flag-line"></i> Fim: {{ formatTimeOnly(r.dataFim) }}</span>
              <span><i class="ri-map-pin-check-line"></i> {{ r.totalPontosCriticosChecados }}/{{ r.totalPontosCriticos
                }} Pontos Checados</span>
            </div>

            <p class="ronda-obs" *ngIf="r.observacao"><i class="ri-sticky-note-line"></i> {{ r.observacao }}</p>

            <div class="pontos-criticos-wrap" *ngIf="r.pontosCriticos && r.pontosCriticos.length">
              <span class="pontos-title">Pontos de Verificação / Checkpoints:</span>
              <div class="pontos-grid">
                <div class="ponto-item" *ngFor="let p of r.pontosCriticos" [class.checked]="p.checado">
                  <i [class]="p.checado ? 'ri-checkbox-circle-fill green' : 'ri-close-circle-line grey'"></i>
                  <div class="ponto-info">
                    <strong class="ponto-name">{{ p.ordem }}. {{ p.designacao }}</strong>
                    <span class="ponto-loc" *ngIf="p.localizacao">{{ p.localizacao }}</span>
                    <small class="ponto-time" *ngIf="p.checado && p.dataChecagem"><i class="ri-time-line"></i> {{
                      formatTimeOnly(p.dataChecagem) }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sub-section-block" *ngIf="anexosEscala.length && !loadingHistorico">
        <h4 class="sub-section-title"><i class="ri-image-line"></i> Fotos & Evidências da Escala</h4>
        <div class="anexos-escala-gallery">
          <div class="anexo-escala-card" *ngFor="let anexo of anexosEscala">
            <img [src]="getAnexoPreviewUrl(anexo.anexoId)" [alt]="anexo.tipoAnexoEscala" loading="lazy" />
            <div class="anexo-escala-overlay">
              <span class="anexo-type">{{ anexo.tipoAnexoEscala || 'Fotografia' }}</span>
              <small class="anexo-date" *ngIf="anexo.dataCriacao">{{ formatDateTime(anexo.dataCriacao) }}</small>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!escalaIdValida && !loadingHistorico && !loadingStats" class="history-selection-empty">
        <span class="history-selection-icon">
          <i class="ri-cursor-line"></i>
          <b><i class="ri-history-line"></i></b>
        </span>
        <strong>Selecione um dia no calendário</strong>
        <p>Clique num horário escalado para consultar ocorrências, rondas e evidências desse turno.</p>
        <span class="history-selection-tip"><i class="ri-arrow-up-line"></i> O histórico será apresentado aqui</span>
      </div>

      <ng-container *ngIf="escalaIdValida || loadingHistorico || loadingStats">
        <div class="activity-stream" *ngIf="eventosOperacionais.length && !loadingHistorico">
          <div class="hist-item" *ngFor="let ev of eventosOperacionais">
            <div class="hist-dot-wrap">
              <div class="hist-dot" [ngClass]="ev.cor"></div>
              <div class="hist-line"></div>
            </div>
            <div class="hist-body">
              <div class="hist-title-row">
                <span class="hist-title">
                  <i [class]="ev.icone"></i>
                  {{ ev.titulo }}
                </span>
                <span class="hist-time" *ngIf="ev.hora">
                  <i class="ri-time-line"></i> {{ ev.hora }}
                </span>
              </div>
              <p class="hist-desc" *ngIf="ev.detalhes">
                {{ ev.detalhes }}
              </p>
            </div>
          </div>
        </div>

        <app-escala-historico *ngIf="
          ocorrenciasDaEscala.length ||
          loadingHistorico ||
          loadingStats ||
          loadingOcorrenciasDaEscala ||
          !eventosOperacionais.length
        " [items]="ocorrenciasDaEscala" [loading]="
          loadingHistorico || loadingStats || loadingOcorrenciasDaEscala
        " emptyText="Este efectivo não registou ocorrências na escala selecionada."></app-escala-historico>

        <div class="history-pagination" *ngIf="!loadingOcorrenciasDaEscala && ocorrenciasEscalaTotal > 0">
          <app-paginator-control [first]="ocorrenciasEscalaFirst" [rows]="ocorrenciasEscalaPageSize"
            [totalRecords]="ocorrenciasEscalaTotal" [rowsPerPageOptions]="[5, 10, 20]"
            (pageChange)="onOcorrenciasEscalaPageChange($event)"></app-paginator-control>
        </div>
      </ng-container>
    </div>

    <!-- ── EQUIPAMENTOS DA ESCALA ── -->
    <div class="section-card" *ngIf="
        efetivo?.escalasPostos?.escalas?.[0]?.equipamentosUtilizados?.length
      ">
      <div class="section-card-header">
        <i class="fas fa-shield-alt"></i>
        <span>Equipamentos em Uso</span>
      </div>
      <div class="equip-list">
        <div class="equip-item" *ngFor="
            let eq of efetivo.escalasPostos.escalas[0].equipamentosUtilizados
          ">
          <div class="equip-icon-wrap">
            <i class="fas fa-shield-alt"></i>
          </div>
          <div class="equip-info">
            <span class="equip-nome">{{ eq.nomeEquipamento }}</span>
            <span class="equip-tipo">{{ eq.tipoEquipmanto }}</span>
          </div>
          <div class="equip-states">
            <span class="state-chip" [class.active]="eq.isCheckIn">
              <i class="ri-login-box-line"></i> IN
            </span>
            <span class="state-chip" [class.active]="eq.isCheckOut">
              <i class="ri-logout-box-line"></i> OUT
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── FOOTER ── -->
  <ng-template pTemplate="footer">
    <div class="drawer-footer" *ngIf="!loading && efetivo">
      <button class="btn-footer-secondary" (click)="onClose()">Fechar</button>
      <button class="btn-footer-primary" (click)="abrirFichaCompleta()">
        <i class="ri-external-link-line"></i> Detalhes
      </button>
    </div>
  </ng-template>
</p-drawer>

<!-- ── DIÁLOGO AFASTAR EFETIVO ── -->
<p-dialog [(visible)]="displayAfastar" [modal]="true" [style]="{ width: '480px' }" [dismissableMask]="true"
  styleClass="afastar-dialog modal-operacional" appendTo="body">
  <ng-template pTemplate="header">
    <div class="afastar-dialog-header">
      <i class="ri-user-unfollow-line"></i>
      <span>Afastar Efectivo</span>
    </div>
  </ng-template>

  <div class="afastar-dialog-body">
    <p class="afastar-dialog-desc">
      <strong>{{ efetivo?.nome }}</strong> será marcado como afastado. Indique o
      motivo para manter o histórico actualizado.
    </p>
    <div class="afastar-field">
      <label for="motivoAfastamento">
        Motivo do Afastamento <span class="required-mark">*</span>
      </label>
      <textarea id="motivoAfastamento" pInputTextarea [(ngModel)]="motivoAfastamento" rows="4" maxlength="240"
        placeholder="Ex.: Baixa médica, licença sem vencimento, processo disciplinar…"></textarea>
      <span class="afastar-char-count">{{ motivoAfastamento.length }}/240</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn-web-secondary" (click)="displayAfastar = false">
      Cancelar
    </button>
    <button class="btn-web-danger" (click)="confirmarAfastar()"
      [disabled]="!motivoAfastamento.trim() || loadingAfastar">
      {{ loadingAfastar ? "A afastar..." : "Afastar" }}
    </button>
  </ng-template>
</p-dialog>

<!-- ── DIÁLOGO SUSPENDER EFETIVO ── -->
<p-dialog [(visible)]="displaySuspender" [modal]="true" [style]="{ width: '520px' }" [dismissableMask]="true"
  styleClass="suspender-dialog modal-operacional" appendTo="body">
  <ng-template pTemplate="header">
    <div class="suspender-dialog-header">
      <i class="ri-pause-circle-line"></i>
      <span>Suspender Efectivo</span>
    </div>
  </ng-template>

  <div class="suspender-dialog-body">
    <p class="suspender-dialog-desc">
      <strong>{{ efetivo?.nome }}</strong> 
      <br>
      <span class="text-info">Terá o seu estado alterado para Suspenso. Por favor, preencha as informações necessárias.</span>
    </p>

    <div class="suspender-field mb-3">
      <label for="motivoSuspensao">
        Motivo da Suspensão <span class="required-mark">*</span>
      </label>
      <p-select
        id="motivoSuspensao"
        [options]="opcoesMotivoSuspensao"
        [(ngModel)]="motivoSuspensao"
        optionLabel="label"
        optionValue="value"
        placeholder="Selecione o motivo"
        appendTo="body"
        styleClass="w-full select-motivo"
        class="motivo-suspensao">
      </p-select>
    </div>

    <div class="suspender-field mb-3">
      <label for="dataSuspensao">
        Data da Suspensão <span class="required-mark">*</span>
      </label>
      <input
        id="dataSuspensao"
        class="text-area suspender-date"
        type="date"
        [(ngModel)]="dataSuspensao">
    </div>

    <!-- ── TEXTAREA ADICIONADO PARA O MOTIVO "OUTRO" ── -->
    <div class="suspender-field mb-3" *ngIf="motivoSuspensao === 5">
      <label for="outroMotivo">
        Especifique o Motivo <span class="required-mark">*</span>
      </label>
      <textarea
        class="text-area"
        id="outroMotivo"
        pInputTextarea
        [(ngModel)]="outroMotivo"
        rows="3"
        maxlength="240"
        placeholder="Descreva aqui o outro motivo de suspensão...">
      </textarea>
      <span class="suspender-char-count">{{ outroMotivo.length }}/240</span>
    </div>

    <div class="suspender-field">
      <label for="observacaoSuspensao" class="obs">
        Observação
      </label>
      <textarea
        class="text-area"
        id="observacaoSuspensao"
        pInputTextarea
        [(ngModel)]="observacaoSuspensao"
        rows="4"
        maxlength="240"
        placeholder="Detalhes ou observações adicionais relativas à suspensão...">
      </textarea>
      <span class="suspender-char-count">{{ observacaoSuspensao.length }}/240</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn-web-secondary btn-modal" (click)="displaySuspender = false">
      Cancelar
    </button>
    <button class="btn-web-secondary btn-action-amber btn-modal" (click)="confirmarSuspender()"
      [disabled]="motivoSuspensao === null || !dataSuspensao || (motivoSuspensao === 5 && !outroMotivo.trim()) || loadingSuspender">
      <i class="ri-pause-circle-line"></i>
      {{ loadingSuspender ? "A suspender..." : "Suspender Efectivo" }}
    </button>
  </ng-template>
</p-dialog>
